import { render, staticRenderFns } from "./ShippingAdvises.vue?vue&type=template&id=0d7e6878"
import script from "./ShippingAdvises.vue?vue&type=script&lang=js"
export * from "./ShippingAdvises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports